import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
import { Fragment } from 'react';
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section data-testid="match-signal-loading">{[...Array(5).keys()].map(_temp)}</section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const Header = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex justify-between gap-1 px-2 py-3"><Shimmer height="25px" width="150px" /><Shimmer height="25px" width="150px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const Content = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div id="match-description" className="px-2 py-3"><Shimmer height="25px" className="mb-1" /><Shimmer height="25px" className="mb-1" /><Shimmer height="25px" className="mb-6" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Loading;
function _temp(value) {
  return <Fragment key={value}><div className="mb-1"><Header /></div><div className="mb-3"><Content /></div></Fragment>;
}